// extracted by mini-css-extract-plugin
export default {"relationshipTypeCell":"RelationshipTypeCell_relationshipTypeCell__3BBeY","changeMap":"RelationshipTypeCell_changeMap__gOto7"};